import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

class DropDownSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.selected || { value: null, title: 'Placeholder' }
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.selected !== this.props.selected) {
            this.setState({ selected: nextProps.selected });
        }
    }

    render() {
        return (
            <div className='dropdown-selector-container' style={ this.props.containerStyles }>
                <div className='display'>{this.state.selected.title}</div>
                <select className='dropdown-options-container' onChange={ this.selectOption }>
                    <option default>{this.state.selected.title}</option>
                    {this.props.options.map((option, idx) =>
                        (<option
                            key={ idx }
                            value={ idx }
                            selected={ this.state.selected.value === option.value }>{option.title}</option>))}
                </select>
                <i className='fa fa-caret-down dropdown-caret' style={ { fontSize: '20px' } } />
            </div>
        );
    }

    selectOption = (e) => {
        const selectedOption = this.props.options[parseInt(e.target.value, 10)];
        this.setState({ selected: selectedOption }, () => {
            this.props.callBack(selectedOption);
        });
    }
}

DropDownSelector.defaultProps = {
    selected: null,
    containerStyles: null,
    options: [],
    callBack: () => ({})
};

DropDownSelector.propTypes = {
    selected: PropTypes.object,
    containerStyles: PropTypes.object,
    options: PropTypes.array,
    callBack: PropTypes.func
};

export default DropDownSelector;
